app.controller('orderPlacementController', ['$scope', '$location',
    'WdHttpService', 'sessionService', 'analyticsService',
    function($scope, $location, WdHttpService, sessionService, analyticsService) {

        // Init 
        $scope.init = async function() {

            $scope.userName = sessionService.get("cognito_username");
            $scope.investingMode = sessionService.get("investingMode") ? sessionService.get("investingMode") : "REAL";
            $scope.stockList = [];
            $scope.showPageLoader();
            $scope.hideConfirmBtn = false;
            $scope.purpose = '';
            
            await $scope.getWalletBalance();

            if ($location.search().orderId) {
                $scope.getStockList();
            }
        }

        $scope.getWalletBalance = async function() {
            var data = { investingMode: $scope.investingMode };
            await WdHttpService._get_wallet_balance(data)
                .then(function(response) {
                    if (typeof response == 'number') {
                        $scope.available = true;
                        $scope.notAvailable = false;
                        $scope.walletBalance = response;
                    } else {
                        $scope.walletBalance = undefined;
                    }
                }).catch(error => {
                    $scope.walletBalance = undefined;
                    $scope.showErrorPopup('Failed to fetch your balance, kindly relogin and try again.');
                });
        }

        $scope.getStockList = async function() {
            var orderId = $location.search().orderId;
            var data = {
                orderId: orderId,
                brokerAuthentication: {
                    "sessionId": sessionService.get("brokerName"),
                    "transactionId": JSON.stringify({
                        "groupId": "",
                        "sessionId": "",
                        "transactionId": ""
                    })
                }
            }
            await WdHttpService._get_stock_splits(data).then(async response => {
                if (response.status == 200) {
                    $scope.stockListData = response.data.subscriptionSharesDetails;
                    $scope.ordersMetaData = response.data.ordersMetaData;
                    $scope.freezedAdviseDetails = response.data.freezedAdviseDetails;
                    $scope.subscribeFundActionKey = response.data.fundActionKey;
                    $scope.adviserUsername = response.data.adviserUsername;
                    $scope.fundName = response.data.fundName;
                    $scope.purpose = response.data.purpose;
                    $scope.displayName = response.data.displayName;

                    $scope.totalSellValue = 0;
                    $scope.totalBuyValue = 0;

                    angular.forEach($scope.stockListData, function(value, key) {
                        if (key == 'Cash') {
                            $scope.cashValue = value.currentMarketValue;
                        } else {
                            $scope.stockList.push({
                                "share": key,
                                "adviseType": value.adviseType,
                                "currentMarketValue": value.currentMarketValue,
                                "exchange": value.exchange,
                                "price": value.price,
                                "sharesQuantity": value.sharesQuantity,
                                "adviseId": value.adviseId,
                                "wdId": value.wdId,
                                "rounding": value.rounding,
                                "allocation": value.allocation,
                                "rationale": value.rationale,
                            });
                            if (value.adviseType.toUpperCase() == 'BUY') {
                                $scope.totalBuyValue = $scope.totalBuyValue + value.currentMarketValue;
                            }
                            if (value.adviseType.toUpperCase() == 'SELL') {
                                $scope.totalSellValue = $scope.totalSellValue + value.currentMarketValue;
                            }
                        }
                    });

                    var eventData = {
                        'fundName': $scope.fundName.toLowerCase()
                    };
                    await analyticsService._push_custom_event_data_to_datalayer('order-execution-' + response.data.purpose.toLowerCase(), eventData);

                    $scope.hidePageLoader();
                }
            }).catch(error => {
                console.log(error);
                if (typeof error == "string") {
                    if (error.toLowerCase() == "you have already one action pending in this wealthbasket, please complete that action.") {
                        $scope.showErrorPopup("You have transaction upload pending. Please click Ok to upload trades to get seamless tracking and updates of your Investment.", () => window.location.href = '/upload-trades', false);
                    } else {
                        onErrorSubscriptionCallback($scope, error);
                    }
                } else {
                    onErrorSubscriptionCallback($scope, error);
                }
                $scope.hidePageLoader();
            })
        }

        $scope.confirmBuyFundClick = function() {

            $scope.showPageLoader();
            var adviser = $scope.adviserUsername;
            var fund = $scope.fundName;
            var currentDate = new Date();
            var tdyDate = currentDate.getDate() + "" + (currentDate.getMonth() + 1) + "" + currentDate.getFullYear();
            var tdayTime = currentDate.getHours() + "" + currentDate.getMinutes() + "" + currentDate.getSeconds();
            var basketId = $scope.userName + '_' + 'SUB' + '_' + tdyDate + tdayTime;
            var brokerSessionObject = sessionService.get('sessionObject');

            var data = {
                investingMode: $scope.investingMode,
                basketOrderId: basketId,
                wealthCode: "1234",
                investingPurpose: $scope.purpose,
                approvalResponse: "Approve",
                adviserUsername: adviser,
                fundName: fund,
                subscriptionSharesDetails: $scope.stockListData,
                freezedAdviseDetails: $scope.freezedAdviseDetails,
                fundActionKey: $scope.subscribeFundActionKey,
                marginAmount: $scope.walletBalance,
                brokerAuthentication: {
                    "sessionId": sessionService.get("brokerName"),
                    "transactionId": JSON.stringify({
                        "groupId": "",
                        "sessionId": "",
                        "transactionId": ""
                    })
                }
            };

            $scope.hideConfirmBtn = true;
            var wdService = WdHttpService;
            WdHttpService._user_basket_approval(data)
                .then(async function(response) {
                    if (response.status == 200) {
                        onSuccessSubscriptionCallback($scope);
                    } else {
                        $scope.showErrorMessageInSubscribeForm('Sorry, Something went wrong!.');
                    }
                    $scope.stopLoading("#confirmInvestButton");
                }).catch(error => {
                    $scope.hidePageLoader();
                    onErrorSubscriptionCallback($scope, error);
                });
        }

        $scope.redirectToAmw = async function(page) {
            await analyticsService._push_custom_event_data_to_datalayer('order-execution-cancelled-for-this-' + $scope.purpose.toLowerCase() + '-' + $location.search().orderId.toLowerCase()  , {});
            if ($location.search().path) {
                window.location.href = $location.search().path + '/' + page;
            } else {
                window.location.href = '/';
            }
        }

        async function onErrorSubscriptionCallback($scope, error) {
            $scope.confirmError = true;
            $scope.confirmErrorMessage = error;
            await $('#failureModal').modal('show');
            await analyticsService._push_custom_event_data_to_datalayer('order-execution-failed-for-this-' + $location.search().orderId.toLowerCase(), {});
            $scope.$evalAsync();
        }

        async function onSuccessSubscriptionCallback($scope, msg = undefined) {
            $scope.subcritionSuccessMsg = msg;
            $scope.hidePageLoader();
            await $('#congratsModal').modal({
                backdrop: 'static',
                keyboard: false,
                show: true
            })
            await analyticsService._push_custom_event_data_to_datalayer('order-execution-success-' + $scope.purpose.toLowerCase(), {});
            $scope.$evalAsync();

        }
    }
]);